import { dataLayer } from '@/v2/utils/dataLayer';

export const dealPageDataLayer = () => {
  return dataLayer.push({
    event: 'pageView',
    pageType: 'Deals Page',
  });
};

// PO Card Events
export const viewAllOptionsDataLayerEvent = () =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: 'View all options',
    label: 'Deals Page',
  });

export const checkAvailabilityDataLayerEvent = () =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: 'Check availability',
    label: 'Deals Page',
  });

export const viewPackageDetailsDataLayerEvent = () =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: 'Deal details and terms',
    label: 'Deals Page',
  });

export const viewPointAccordionDetailsDataLayerEvent = (
  groupName: string,
  itemName: string,
) =>
  dataLayer.accordionOpenEvent({
    groupName,
    itemName,
  });
